import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { faTrash as faTrashSolid } from '@fortawesome/pro-solid-svg-icons';
import { IIntegrationResponse } from '@kcftech/prometheustypescriptapiclient';
import { useMutation } from '@tanstack/react-query';
import { HoverIconButton } from 'components/button/HoverIconButton';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { useNotificationContext } from 'contexts/NotificationContext';
import { useState } from 'react';
import { useThemeValues } from 'styles/theme';
import { deleteIntegration } from 'utils/integration';

export type DeleteIntegrationCellProps = Readonly<{
    rowData: IIntegrationResponse;
    onChange: () => void;
    locationId: string;
}>;

export function DeleteIntegrationCell({
    locationId,
    rowData,
    onChange,
}: DeleteIntegrationCellProps) {
    const { showToast } = useNotificationContext();
    const { secondaryText, deleteButton } = useThemeValues();
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const { mutate: deleteIntegrationAssignment, isPending: isDeleting } = useMutation({
        mutationFn: () =>
            deleteIntegration({
                locationId,
                integration: rowData,
            }),

        onSuccess: () => {
            onChange();
            setConfirmModalOpen(false);
            showToast({
                type: 'success',
                content: 'Successfully deleted integration',
            });
        },

        onError: () => {
            showToast({
                type: 'error',
                content: 'Failed to delete integration',
            });
        },
    });

    return (
        <div className="flex-row align-center flex-nowrap f-16">
            <HoverIconButton
                icon={faTrash}
                hoverIcon={faTrashSolid}
                color={secondaryText}
                hoverColor={deleteButton}
                onClick={() => setConfirmModalOpen(true)}
            />
            {confirmModalOpen && (
                <ConfirmModal
                    title={`Delete ${rowData.SoftwareName} Integration`}
                    actionText="delete this integration?"
                    checkText="delete this integration"
                    closable={!isDeleting}
                    actionable={!isDeleting}
                    actionButtonText="Delete"
                    onAction={deleteIntegrationAssignment}
                    onClose={() => setConfirmModalOpen(false)}
                />
            )}
        </div>
    );
}
